

// import { useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { refreshAccessToken } from "./api";
// import { refreshTokenSuccess, refreshTokenFailure } from "../store/authSlice";
// import Cookies from "js-cookie";

// function useAuthRefreshOnLoad() {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     async function refresh() {
//       // Check if we have a refresh token
//       const refreshToken = Cookies.get("refresh_token");
      
//       if (!refreshToken) {
//         // No refresh token, no need to try refresh
//         dispatch(refreshTokenFailure("No refresh token found"));
//         return;
//       }
      
//       // Check if we have an expired or missing access token
//       const existingToken = Cookies.get("access_token");
      
//       if (!existingToken) {
//         // Only refresh if we don't have a token
//         const newToken = await refreshAccessToken();
//         if (!newToken) {
//           dispatch(refreshTokenFailure("Session expired"));
//         }
//       } else {
//         // We have a token, dispatch success to update Redux state
//         dispatch(refreshTokenSuccess({ access: existingToken }));
//       }
//     }
    
//     // Add a small delay to ensure cookies are fully loaded
//     setTimeout(refresh, 100);
//   }, [dispatch]);
// }

// export default useAuthRefreshOnLoad;



import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { refreshAccessToken, validateActiveRole } from "./api";
import { refreshTokenSuccess, refreshTokenFailure } from "../store/authSlice";
import Cookies from "js-cookie";

function useAuthRefreshOnLoad() {
  const dispatch = useDispatch();

  useEffect(() => {
    async function refresh() {
      const refreshToken = Cookies.get("refresh_token");

      if (!refreshToken) {
        dispatch(refreshTokenFailure("No refresh token found"));
        return;
      }

      const existingToken = Cookies.get("access_token");

      if (!existingToken) {
        const newToken = await refreshAccessToken();
        if (!newToken) {
          dispatch(refreshTokenFailure("Session expired"));
          return;
        }
      } else {
        dispatch(refreshTokenSuccess({ access: existingToken }));
      }

      // Whatever role is currently in the cookie gets re-checked against
      // the server on every load. If someone hand-edited it, this kicks
      // them out before the menu ever renders with it.
      const valid = await validateActiveRole();
      if (!valid) {
        window.location.href = "/accounts?reason=unauthorized";
      }
    }

    setTimeout(refresh, 100);
  }, [dispatch]);
}

export default useAuthRefreshOnLoad;